import { Typography } from "@mui/material";
import FloatingContainer from "../common/containers/FloatingContainer";
import SettingsWindowButton from "./SettingsWindowButton";
import UserProfileMenuButton from "./userProfileMenu/UserProfileMenuButton";
import MainColorContainer from "../common/containers/MainColorContainer";
import { useViewport } from "../../hooks/others/useViewport";
import { TOP_MENU_PHANTOM_HEIGHT } from "../../utils/constants/viewConstants";

const TopMenu = () => {
    const phantomHeight = useViewport(TOP_MENU_PHANTOM_HEIGHT);

    return (
        <FloatingContainer position="top" phantomSize={phantomHeight}>
            <MainColorContainer className="d-flex flex-row jc-space-between ai-center gap-0_5 full-height p-1 bs-border-box">
                <div className="d-flex flex-row ai-center gap-0_5">
                    <Typography variant="h3">albuMania</Typography>
                </div>
                <div className="d-flex flex-row ai-center jc-end gap-0_5">
                    <UserProfileMenuButton />
                    <SettingsWindowButton />
                </div>
            </MainColorContainer>
        </FloatingContainer>
    )
}

export default TopMenu;